"use strict";
import TextDroppableInput from "../text_droppable_input";
import generalFormatter from "../../formatters/general";
import GeosuggestDroppableInput from "../geosuggest_dropable_input";
export default React.createClass({
  getInitialState() {
    return {
      extractedFields: this.initialFieldsAndValues(this.props),
      toBeCleanedFields: this.toBeCleanedFields()
    };
  },
  toBeCleanedFields: function() {
    return _.chain(this.props.extractedFields).where({ clean_amount: true }).map((f) => {
      return f["name"];
    }).value();
  },
  initialFieldsAndValues(props) {
    const fieldsToDisplay = props.extractedFields || [];
    const keys = _.pluck(fieldsToDisplay, "name");
    const labels = _.pluck(fieldsToDisplay, "label");
    const options = _.pluck(fieldsToDisplay, "options");
    const placeholders = _.pluck(fieldsToDisplay, "placeholder");
    const fieldsSourceObject = props.fieldsSourceObject;
    const fieldValue = (field) => {
      return fieldsSourceObject[field] || "";
    };
    return _.chain(
      _.zip(keys, labels, placeholders, options)
    ).map(
      ([k, l, p, o]) => [
        k,
        {
          label: l,
          value: fieldValue(k),
          placeholder: p,
          options: o
        }
      ]
    ).object().value();
  },
  componentWillReceiveProps(newProps) {
    if (this.props.sourceId !== newProps.sourceId || this.props.isDirty) {
      this.setState({
        extractedFields: this.initialFieldsAndValues(newProps)
      });
    }
  },
  possibleErrorMessage: function(fieldName) {
    if (fieldName === "load_id") {
      var errorMessage = this.props.loadIdError;
    }
    if (errorMessage) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box alert load-detail__load-id-error" }, errorMessage);
    }
  },
  render() {
    if (this.hasExtractedFields()) {
      const fields = _.pairs(this.state.extractedFields) || [];
      const pairsOfFields = _.toArray(
        _.groupBy(
          fields,
          (x, i) => Math.floor(i / 2)
        )
      );
      const renderField = (field, fieldContainerClass, i) => {
        if (field) {
          const [name, { label, value, placeholder, options }] = field;
          var labelElement;
          if (placeholder) {
            labelElement = /* @__PURE__ */ React.createElement(
              "label",
              {
                "data-tooltip": true,
                "aria-haspopup": "true",
                title: placeholder
              },
              this.formatLabel(label, name),
              /* @__PURE__ */ React.createElement("i", { className: "fi-info load-detail__extracted-field-has-tooltip" })
            );
          } else {
            labelElement = /* @__PURE__ */ React.createElement("label", null, this.formatLabel(label, name));
          }
          return /* @__PURE__ */ React.createElement("div", { className: fieldContainerClass, key: "extracted_field_field" + i }, labelElement, this.inputForField(name, value, options));
        }
        ;
      };
      const fieldList = (rowOfFields, rowClass, rowItemClass, i) => {
        return /* @__PURE__ */ React.createElement("div", { className: rowClass, key: "extracted_field_row" + i }, rowOfFields.map(_.partial(renderField, _, rowItemClass, _)));
      };
      if (this.renderRows()) {
        return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, pairsOfFields.map(_.partial(fieldList, _, "row", "small-5 column", _))));
      } else {
        return fieldList(fields, this.containerClass(), this.fieldContainerClass(), 0);
      }
    } else {
      return null;
    }
  },
  formatLabel: function(label, name) {
    return this.isRequiredField(name) ? label + "*" : label;
  },
  labelFor(field) {
    return (field || "").split("_").map((s) => s && s[0].toUpperCase() + s.substring(1, s.length)).join(" ");
  },
  hasExtractedFields() {
    return !_.isEmpty(this.state.extractedFields);
  },
  isRequiredField: function(name) {
    return _.contains(this.props.requiredFields, name);
  },
  isDateField: function(name) {
    return !!(_.findWhere(this.props.extractedFields, { name }) || {}).date_field;
  },
  isGeosuggestInput: function(name) {
    return name === "destination_name" || name === "origin_name";
  },
  inputClass: function(name, value) {
    if (this.isRequiredField(name) && !value) {
      return "load-detail__invalid-input";
    }
  },
  inputForField(name, value, options) {
    if (this.isDateField(name)) {
      return /* @__PURE__ */ React.createElement("div", { className: this.inputClass(name, value) }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "date",
          disabled: this.props.readOnly,
          placeholder: "Date",
          value: value.substring(0, 10),
          onChange: this.inputChangedHandlerFor(name)
        }
      ));
    } else if (options) {
      return /* @__PURE__ */ React.createElement("div", { className: this.inputClass(name, value) }, /* @__PURE__ */ React.createElement(
        "select",
        {
          type: "text",
          placeholder: "Select",
          disabled: this.props.readOnly,
          value,
          onChange: this.inputChangedHandlerFor(name)
        },
        this.inputOptions(options)
      ));
    } else if (this.isGeosuggestInput(name)) {
      return /* @__PURE__ */ React.createElement("div", { className: this.inputClass(name, value) }, /* @__PURE__ */ React.createElement(
        GeosuggestDroppableInput,
        {
          type: "text",
          disabled: this.props.readOnly,
          valueLink: this.autocompleteHandler(name),
          geosuggestClear: this.autocompleteClearHandler(name),
          initialValue: value,
          value,
          nonSelect: this.nonSelect(name)
        }
      ));
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: this.inputClass(name, value) }, /* @__PURE__ */ React.createElement(
        TextDroppableInput,
        {
          type: "text",
          disabled: this.props.readOnly,
          value,
          onDrop: this.inputChangedHandlerFor(name),
          onChange: this.inputChangedHandlerFor(name)
        }
      ), this.possibleErrorMessage(name));
    }
  },
  defaultInputOption: function() {
    return "Select an Option";
  },
  inputOptions: function(options) {
    const opts = [this.defaultInputOption()].concat(options);
    return opts.map(
      (opt) => /* @__PURE__ */ React.createElement("option", { value: opt }, opt)
    );
  },
  updateValues: function(val, fields, name) {
    if (val != this.defaultInputOption()) {
      fields[name].value = val;
    } else {
      fields[name].value = null;
    }
  },
  shouldBeCleaned: function(name, event) {
    return _.contains(this.state.toBeCleanedFields, name) && event.type == "drop";
  },
  inputChangedHandlerFor(name) {
    return (event, value) => {
      const fields = this.state.extractedFields;
      var val = value || event.currentTarget.value;
      if (this.shouldBeCleaned(name, event)) {
        val = generalFormatter.cleanAmount(val).toString() || "0.00";
      }
      this.updateValues(val, fields, name);
      this.setState({ extractedFields: fields });
      this.props.onChange(_.mapObject(fields, _.property("value")));
    };
  },
  autocompleteHandler(name) {
    var props = this.props;
    var component = this;
    return {
      requestChange: function(suggestion) {
        let updatedFields = component.mapSuggestionToFields(suggestion, name);
        component.setState({ extractedFields: updatedFields });
        props.onChange(_.mapObject(updatedFields, _.property("value")));
        props.onLocationChange(updatedFields);
      }
    };
  },
  autocompleteClearHandler(name) {
    var props = this.props;
    var component = this;
    return {
      requestChange: function() {
        let updatedFields = component.clearName(name);
        component.setState({ extractedFields: updatedFields });
        props.onChange(_.mapObject(updatedFields, _.property("value")));
        props.onLocationChange(updatedFields);
      }
    };
  },
  clearName: function(name) {
    let fields = this.state.extractedFields;
    _.mapObject(fields, function(value, key) {
      fields[name].value = "";
    });
    return fields;
  },
  nonSelect(name) {
    var props = this.props;
    var component = this;
    return {
      requestChange: function(inputValue) {
        let fields = component.state.extractedFields;
        fields[name].value = inputValue;
        component.setState({ extractedFields: fields });
        props.onChange(_.mapObject(fields, _.property("value")));
        props.onLocationChange(fields);
      }
    };
  },
  mapSuggestionToFields: function(suggestion, name) {
    let fields = this.state.extractedFields;
    if (name == "origin_name") {
      let originData = this.createOriginData(suggestion);
      _.mapObject(originData, function(value, key) {
        if (fields[key] != void 0) {
          fields[key].value = value;
        } else {
          fields[key] = { value };
        }
      });
    } else if (name == "destination_name") {
      let destinationData = this.createDestinationData(suggestion);
      _.mapObject(destinationData, function(value, key) {
        if (fields[key] != void 0) {
          fields[key].value = value;
        } else {
          fields[key] = { value };
        }
      });
    }
    return fields;
  },
  createOriginData: function(suggestion) {
    let description = suggestion.description;
    let addressComponents = suggestion.gmaps.address_components;
    let locationData = {
      origin_address_line_1: null,
      origin_address_line_2: null,
      origin_city: null,
      origin_name: description.split(",")[0],
      origin_postal_code: null,
      origin_state: null,
      origin_country: null,
      origin_lat: suggestion.location.lat,
      origin_lng: suggestion.location.lng
    };
    addressComponents.map((component) => {
      switch (component.types[0]) {
        case "subpremise":
          locationData.origin_address_line_2 = component.long_name;
          break;
        case "locality":
          locationData.origin_city = component.long_name;
          break;
        case "administrative_area_level_1":
          locationData.origin_state = component.short_name;
          break;
        case "postal_code":
          locationData.origin_postal_code = component.long_name;
          break;
        case "street_number":
          locationData.origin_address_line_1 = component.short_name;
          break;
        case "route":
          locationData.origin_address_line_1 = locationData.origin_address_line_1 + " " + component.short_name;
          break;
        case "country":
          locationData.origin_country = component.short_name;
          break;
      }
    });
    return locationData;
  },
  createDestinationData: function(suggestion) {
    let description = suggestion.description;
    let addressComponents = suggestion.gmaps.address_components;
    let locationData = {
      destination_address_line_2: null,
      destination_address_line_1: null,
      destination_city: null,
      destination_name: description.split(",")[0],
      destination_postal_code: null,
      destination_state: null,
      destination_country: null,
      destination_lat: suggestion.location.lat,
      destination_lng: suggestion.location.lng
    };
    addressComponents.map((component) => {
      switch (component.types[0]) {
        case "subpremise":
          locationData.destination_address_line_2 = component.long_name;
          break;
        case "locality":
          locationData.destination_city = component.long_name;
          break;
        case "administrative_area_level_1":
          locationData.destination_state = component.short_name;
          break;
        case "postal_code":
          locationData.destination_postal_code = component.long_name;
          break;
        case "street_number":
          locationData.destination_address_line_1 = component.short_name;
          break;
        case "route":
          locationData.destination_address_line_1 = locationData.destination_address_line_1 + " " + component.short_name;
          break;
        case "country":
          locationData.destination_country = component.short_name;
          break;
      }
    });
    return locationData;
  },
  renderRows() {
    if (this.props.renderRows !== null && this.props.renderRows !== void 0) {
      return this.props.renderRows;
    } else {
      return true;
    }
  },
  fieldContainerClass() {
    return this.props.fieldContainerClass || "";
  },
  containerClass() {
    return this.props.containerClass || "";
  }
});
